import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { ConfirmDialog, DeleteButton, ListActionButtonProps } from "sprint-common-web";

import { useAdminAirlineApi } from "../../../../airline/common/api/useAdminAirlineApi";
import { SystemPlatformListingContext } from "../../context/SystemPlatformListingContext";

export const RemoveSystemPlatformButton: React.FC<ListActionButtonProps> = ({
    itemId,
    id,
    disabled
}: ListActionButtonProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

    const { deleteSystemPlatform } = useContext(SystemPlatformListingContext);
    const { removeSystemPlatform } = useAdminAirlineApi();
    const { airlineId } = useParams<{ airlineId: string }>();

    const closeDialog = () => {
        setIsDialogOpen(false);
    };

    const openDialog = () => {
        setIsDialogOpen(true);
    };

    const handleRemove = async () => {
        await removeSystemPlatform({ airlineId, systemId: itemId });

        deleteSystemPlatform(itemId);
        closeDialog();
    };

    return (
        <>
            <DeleteButton key={id} disabled={disabled} onClick={openDialog} />
            <ConfirmDialog
                confirm={{ onClick: handleRemove }}
                cancel={{ onClick: closeDialog }}
                hidden={!isDialogOpen}
                title="Remove"
                text="Are you sure you want to remove this?"
            />
        </>
    );
};
